import { FunctionComponent, useEffect, useLayoutEffect, useReducer } from 'react';
import { useLocation } from 'react-router-dom';
import { ShellContentSkeleton } from '../Layout/ShellContentSkeleton';
import { routeSkeletonMounted } from './routeSkeletonHandoff';
import { findDeferred } from './routeSkeletonRegistry';
/** Esqueleto de la ruta `path`, o de la URL actual si no se pasa (carcasa de arranque). */
export const RouteSkeleton: FunctionComponent<{ path?: string }> = ({ path }) => {
  const { pathname } = useLocation();
  const entry = findDeferred(path ?? pathname);
  const [, chunkArrived] = useReducer((n: number) => n + 1, 0);
  // Si el chunk llega mientras el genérico sigue en pantalla, pasa al de la pantalla.
  useEffect(() => {
    if (entry && !entry.Component) void entry.load().then(chunkArrived);
  }, [entry]);
  const Skeleton = entry?.Component ?? ShellContentSkeleton;
  // Solo el esqueleto propio cuenta para el relevo: tras el genérico, la pantalla entra
  // con su animación de siempre.
  const isOwn = Skeleton !== ShellContentSkeleton;
  useLayoutEffect(() => (isOwn ? routeSkeletonMounted() : undefined), [isOwn]);
  return <Skeleton />;
};
